<div class="flex flex-col pb-10">
  <app-modal
    (closeEmitter)="showCardConfirmationModal = false"
    [showModal]="showCardConfirmationModal"
    (click)="preventClose($event)"
  >
    <p class="border-b-2 text-start text-xl font-bold">Submit These Cards?</p>

    <div class="mt-5 flex items-center justify-center space-x-2">
      <ng-container *ngFor="let card of submittedCards">
        <div class="relative">
          <img
            src="assets/cards/{{ card.cardType }}/{{ card.number }}-{{ card.cardType }}.svg"
            class="h-auto w-44"
          />
        </div>
      </ng-container>
    </div>
    <div class="mt-5">
      <p class="text-center font-bold">
        {{
          mode === modeType.PlayerCards
            ? 'Player Cards'
            : mode === modeType.MaverickCard
              ? 'Maverick Card'
              : ''
        }}
      </p>
    </div>
    <div class="mt-10 flex items-center justify-end space-x-2 font-semibold">
      <button
        (click)="showCardConfirmationModal = false"
        class="secondary-btn flex h-10 items-center border border-black"
      >
        Cancel
      </button>
      <button (click)="handleConfirmation()" class="primary-btn flex h-10 items-center">
        Confirm
      </button>
    </div>
  </app-modal>

  <app-infuse-pot-modal
    [showInjectPotModal]="showInjectPotModal"
    [dealerId]="dealerId"
    (closeEmitter)="showInjectPotModal = false"
  ></app-infuse-pot-modal>

  <!-- <div
    class="absolute -top-12 left-0 z-50 ml-2"
    *ngIf="!showInjectPotModal && !showCardConfirmationModal"
  >
    <button
      class="hover:bg-neutral-00 flex items-center justify-center rounded-lg bg-neutral-50 bg-opacity-30 px-4 py-2"
      (click)="backToGamePanelMenu()"
    >
      <ng-container *ngIf="showSpinner; else showBackButton">
        <mat-spinner
          color="warn"
          class="spinner bg-transparent"
          [strokeWidth]="3"
          [diameter]="20"
        ></mat-spinner>
      </ng-container>
      <ng-template #showBackButton>
        <ng-container *ngIf="isSmallScreen; else showExitText">
          <svg-icon
            src="assets/svg/icons/ArrowLeft.svg"
            [svgStyle]="{ 'width.px': 18, 'height.px': 20 }"
          ></svg-icon>
        </ng-container>
        <ng-template #showExitText> Exit </ng-template>
      </ng-template>
    </button>
  </div> -->

  <!-- Filter and label -->
  <div class="relative w-full bg-stone-950 px-2 py-10 md:px-5 md:py-4">
    <div class="text-sm sm:text-sm md:mt-2 md:text-2xl lg:text-2xl xl:text-2xl">
      <div class="flex justify-between">
        <p>{{ modeDescription }}</p>
        <div></div>
        <!-- <p>
          <span>Total Pot: </span> <span class="font-bold">{{ totaPot | number: '1.0-2' }}</span>
        </p> -->
      </div>
    </div>
    <div class="relative flex flex-col-reverse items-center md:flex-row md:justify-between">
      <!-- Common Sort By Section -->
      <div
        class="mt-2 flex items-center justify-center space-x-2 text-xs sm:text-xs md:mt-0 md:flex md:text-xs lg:text-sm xl:text-sm"
      >
        <label> Sort By: </label>
        <button
          (click)="filterCards('')"
          [ngClass]="selectedFilter === '' ? 'secondary-btn' : 'primary-btn'"
        >
          All
        </button>
        <button
          class="primary-btn"
          *ngFor="let cardType of cardTypes"
          [ngClass]="selectedFilter === cardType.value ? 'secondary-btn' : 'primary-btn'"
          (click)="filterCards(cardType.value)"
        >
          <svg-icon
            [svgStyle]="{
              'width.px': 18,
              'height.px': 20,
              fill: selectedFilter === cardType.value ? 'black' : 'white'
            }"
            [src]="'assets/svg/icons/' + (cardType.value | camelCaseToTitle) + '.svg'"
            class="text-sm"
            [ngClass]="selectedFilter === cardType.value ? 'text-black' : 'text-white'"
          ></svg-icon>
        </button>
        <button class="primary-btn" (click)="sortCards()">
          <ng-container *ngIf="isAsc; else descIcon">
            <svg-icon
              [svgStyle]="{ 'width.px': 18, 'height.px': 20 }"
              src="assets/svg/icons/SortDescending.svg"
            ></svg-icon>
          </ng-container>
          <ng-template #descIcon>
            <svg-icon
              [svgStyle]="{ 'width.px': 18, 'height.px': 20 }"
              src="assets/svg/icons/SortAscending.svg"
            ></svg-icon>
          </ng-template>
        </button>
      </div>

      <!-- Common Search Bar Section -->
      <div
        class="mt-2 flex h-12 w-full items-center rounded-lg border-2 bg-white text-sm text-black md:w-72"
      >
        <fa-icon icon="search" class="ml-4 mr-3"></fa-icon>
        <div class="flex h-full flex-1 flex-nowrap font-light">
          <div class="relative flex h-full flex-1 items-center pr-3">
            <input
              type="text"
              class="w-full bg-white text-lg font-normal focus:outline-none"
              [(ngModel)]="searchTerm"
              placeholder="Search"
              (input)="search()"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Dealer's Name Positioned at the Bottom -->

    <!-- <p
      class="absolute bottom-0 left-2 transform md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:text-2xl"
    >
      {{ selectedDealer ? selectedDealer.name : '' }}
    </p> -->

    <!-- Selected Cards Positioned at the Bottom -->
    <div
      class="absolute -bottom-4 right-2 mt-4 flex flex-row items-center justify-center md:bottom-5 md:left-1/2 md:right-0 md:-translate-x-1/2 md:transform"
      *ngIf="selectedCards.length > 0"
    >
      <p class="text-center font-normal">Selected Cards:</p>
      <div class="ml-1 mt-4 grid grid-cols-2 md:mb-5 md:gap-1">
        <ng-container *ngFor="let card of selectedCards; let i = index">
          <app-small-card
            [number]="card.number"
            [type]="card.cardType"
            class="h-12 w-auto"
          ></app-small-card>

          <!-- <img
            src="assets/cards/{{ card.cardType }}/{{ card.number }}-{{ card.cardType }}.svg"
            class="ml-2 h-6 w-auto md:h-auto md:w-12"
          /> -->
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Displaying Cards -->
  <div *ngIf="filteredCards.length > 0; else elseBlock">
    <div
      class="mt-4 grid grid-cols-6 gap-6 px-10 py-2 sm:grid-cols-6 md:grid-cols-13 md:gap-2 lg:grid-cols-13 xl:grid-cols-13"
    >
      <ng-container *ngFor="let card of filteredCards; let i = index">
        <ng-container *ngIf="!isSmallScreen; else smallCards">
          <img
            src="assets/cards/{{ card.cardType }}/{{ card.number }}-{{ card.cardType }}.svg"
            class="h-30 w-20 cursor-pointer transition duration-300 hover:w-32 md:h-40 md:w-28"
            (click)="!canPickCard || isInAllSelectedCards(card) ? null : selectCard(card)"
            [class.opacity-50]="!isInAllSelectedCards(card)"
            [class.opacity-100]="isInAllSelectedCards(card)"
            [class.cursor-pointer]="canPickCard && !isInAllSelectedCards(card)"
            [class.cursor-not-allowed]="!canPickCard || isInAllSelectedCards(card)"
          />
        </ng-container>
        <ng-template #smallCards>
          <app-small-vertical-card
            [number]="card.number"
            [type]="card.cardType"
            class="transition duration-300"
            (click)="!canPickCard || isInAllSelectedCards(card) ? null : selectCard(card)"
            [class.opacity-50]="!isInAllSelectedCards(card)"
            [class.opacity-100]="isInAllSelectedCards(card)"
            [class.cursor-pointer]="canPickCard && !isInAllSelectedCards(card)"
            [class.cursor-not-allowed]="!canPickCard || isInAllSelectedCards(card)"
          ></app-small-vertical-card>
        </ng-template>
      </ng-container>
    </div>
  </div>
  <ng-template #elseBlock>
    <div class="mb-56 mt-56 flex items-center justify-center">
      <p class="text-center text-xl">No Result Found</p>
    </div>
  </ng-template>

  <!-- Footer -->
  <footer
    class="fixed bottom-0 flex w-full items-center justify-between border-t-2 border-black bg-[#1D5315] px-5 py-2"
  >
    <div>
      <button
        *ngIf="mode === modeType.Setup"
        (click)="startGame()"
        class="secondary-btn h-10 font-bold"
      >
        Start
      </button>
      <button
        *ngIf="mode !== modeType.Setup"
        [disabled]="selectedCards.length < selectedLength || !canPickCard"
        (click)="submitCards()"
        class="secondary-btn h-10 font-bold"
      >
        Submit
      </button>
    </div>

    <div class="absolute left-1/2 -translate-x-1/2 transform">
      <button
        class="flex h-10 w-10 items-center justify-center rounded-full bg-white text-4xl text-black shadow hover:shadow-lg"
        (click)="toggleGamePaused()"
      >
        <ng-container *ngIf="mode === modeType.Paused; else pauseIcon">
          <svg-icon src="assets/svg/icons/Play.svg"></svg-icon>
        </ng-container>
        <ng-template #pauseIcon>
          <svg-icon src="assets/svg/icons/Pause.svg"></svg-icon>
        </ng-template>
      </button>
    </div>

    <div *ngIf="!countdown && !showPotButton" class="none"></div>

    <div *ngIf="countdown > 0">
      <app-timer [countdown]="countdown"></app-timer>
    </div>

    <button
      *ngIf="showPotButton"
      class="ml-4"
      (click)="onClickiInfusePot()"
      class="secondary-btn h-10 font-bold"
    >
      Infuse Pot
    </button>
  </footer>
</div>
